import GatsbyImage from 'gatsby-image'
import PropTypes from 'prop-types'
import React from 'react'
import { Flex, Box, Card, BackgroundImage, Subhead, Text } from 'rebass'

const Service = ({ image, title, description }) => (
  <Flex width={[1, 1 / 2, 1 / 3]}>
    <Card m={3} borderRadius={0} boxShadow={0}>
      <Flex flexWrap="wrap">
        <Box width={1}>
          <BackgroundImage
            is={GatsbyImage}
            ratio={2 / 3}
            sizes={image}
            alt={title}
          />
        </Box>
        <Box bg="#ffffff">
          <Subhead
            is="h2"
            color="#E30000"
            fontSize={3}
            px={1}
            py={3}
            fontWeight={400}
          >
            {title}
          </Subhead>
          <Text
            dangerouslySetInnerHTML={{ __html: description }}
            color="#4D4D4D"
            px={1}
            pb="1rem"
            fontSize={2}
          />
        </Box>
      </Flex>
    </Card>
  </Flex>
)

Service.propTypes = {
  image: PropTypes.object,
  title: PropTypes.string,
  description: PropTypes.string,
}

export default Service



// WEBPACK FOOTER //
// ./src/containers/Services/Service.js